import app from "./app.js";
import { getDatabase } from "firebase/database";
export default getDatabase(app);
